import Checkbox from './src/checkbox';
import CheckboxGroup from './src/checkbox-group';

module.exports = {
    Checkbox,CheckboxGroup
}


// WEBPACK FOOTER //
// ./src/components/checkbox/index.js